'use client';

import React, { useState } from 'react';

export default function FloatingCallButton() {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="md:hidden fixed bottom-6 right-6 z-50 flex flex-col items-center gap-2" style={{ pointerEvents: 'none' }}>
      {/* Tooltip — space always reserved to prevent layout shift */}
      <div
        className="transition-opacity duration-200"
        style={{
          pointerEvents: 'none',
          opacity: showTooltip ? 1 : 0,
          minHeight: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        aria-hidden="true"
      >
        <span
          className="block whitespace-nowrap text-white text-xs font-medium px-3 py-1.5 rounded-full shadow-lg"
          style={{ backgroundColor: '#111111' }}
        >
          Speak to a specialist
        </span>
      </div>

      {/* Button */}
      <a
        href="tel:01614001687"
        aria-label="Call us now on 0161 400 1687"
        className="floating-call-btn flex items-center justify-center rounded-full shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2"
        style={{
          width: 64,
          height: 64,
          backgroundColor: '#CC1A1A',
          pointerEvents: 'auto',
          flexShrink: 0,
        }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        onTouchStart={() => setShowTooltip(true)}
        onTouchEnd={() => setShowTooltip(false)}
      >
        {/* Phone SVG icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="white"
          aria-hidden="true"
        >
          <path d="M6.62 10.79a15.053 15.053 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.61 21 3 13.39 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.46.57 3.58a1 1 0 0 1-.25 1.01l-2.2 2.2z" />
        </svg>
      </a>

      <style jsx>{`
        .floating-call-btn {
          animation: callPulse 2s ease-in-out infinite;
        }
        @keyframes callPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.08); }
        }
      `}</style>
    </div>
  );
}
